export default __webpack_public_path__ + "static/media/access-release.40583482.svg";